<app-navbar title="Contratos" />

<div class="py-8 px-4 overflow-y-auto scrollbar-hide max-h-[calc(100vh-5rem)]">
  <app-card>
    <app-card-header title="Contratos" />
    <app-table-contracts
      [loading]="loading()"
      (view)="onContractClick($event)"
    />
  </app-card>
</div>
